var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{attrs:{"cols":"3","id":"notification-container"}},_vm._l((_vm.notifications),function(notification){return _c('notification',{key:notification.id,attrs:{"notification":notification}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }